export const INCLUDE_TRADE_CHANGED = 'INCLUDE_TRADE_CHANGED';
export const TRADE_IN_TOGGLE_MANUAL_FORM = 'TRADE_IN_TOGGLE_MANUAL_FORM';
